// Copy pasted from https://git.hubteam.com/HubSpot/foundations-components/blob/08c9ecae25abc893eb09ab5aad7d50ad589b104c/foundations-components/static/js/transitional/utils/mergeRefs/mergeRefs.ts
// The only reason we're not just importing this is because doing so causes a "Cannot import the following non-public modules" build error.
export function mergeRefs(refs) {
  return value => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}